import { useState } from "react";
import OldFixedAsset from "./OldFixedAsset";
import NewFixedAsset from "./NewFixedAsset";

const FixedAsset = ({ authrztn }) => {
  const [selectedValue, setSelectedValue] = useState("NEW");
  return (
    <div className="w-100 h-100">
      <>
        {selectedValue === "OLD" ? (
          <OldFixedAsset authrztn={authrztn} />
        ) : selectedValue === "NEW" ? (
          <NewFixedAsset authrztn={authrztn} />
        ) : null}
      </>
    </div>
  );
};

export default FixedAsset;
